import { ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { SwiperSlider } from 'newcomponents/UI/SwiperSlider';
import './index.less';

const CATEGORIES_SKELETON_COUNT = 10;

export const CategoriesHorizontalDesktopSkeleton = ({
  namesOnly
}: {
  namesOnly: boolean;
}): ReactElement => {
  return (
    <div className="categoriesHorizontalDesktopWrapper">
      <div
        className={cc([
          'horizontalMenuWrapper horizontalMenuWrapper__skeleton',
          {
            horizontalMenuWrapper__namesOnly: namesOnly
          }
        ])}
        style={{ width: '100%' }}
      >
        <div className="menu" style={{ width: '100%', display: 'block' }}>
          <SwiperSlider
            sliderWrapperClassName={
              namesOnly ? 'casinoCategories__namesOnly__slider' : ''
            }
            activeSlide={0}
            headerTitle={
              namesOnly ? (
                <Skeleton
                  title={{
                    style: {
                      height: 24,
                      width: 150,
                      margin: '8px 0',
                      position: 'relative'
                    }
                  }}
                  paragraph={false}
                  active
                />
              ) : undefined
            }
            bodyArrows={!namesOnly}
            alwaysShowArrows={namesOnly}
            headerArrows={namesOnly}
            style={{ width: '100%' }}
            drawableTabs={createArray(CATEGORIES_SKELETON_COUNT).map(key => (
              <div className="menuItem" key={key}>
                {!namesOnly && <Skeleton.Avatar size={EIconSize._40} active />}
                <span
                  className={cc([
                    {
                      name: !namesOnly,
                      nameOnly: namesOnly
                    }
                  ])}
                >
                  <Skeleton
                    title={{
                      style: {
                        height: namesOnly ? EIconSize._14 : EIconSize._10,
                        width: 70,
                        margin: '3px 10px',
                        position: 'relative'
                      }
                    }}
                    paragraph={false}
                    active
                  />
                </span>
              </div>
            ))}
          />
        </div>
      </div>
    </div>
  );
};
